export default `vec3 Q;
    float i,d=1.,a,b=sqrt(3.);
    Q=mod(p,b*2.)-b;
    a=1.; d=9.;
    for(int j=0;j++<7;){
      Q=abs(Q);
      d=min(d,(dot(Q,vec3(1.0)/b)-1.)/a);
      Q=Q*3.-6./b;a*=3.;
    }
    return d;
  }`